import React from "react";
import { Card, Col, Empty, Row, Statistic, Table, Typography } from "antd";
import moment from "moment";

const { Text } = Typography;

const formatMoney = (currency, amount) =>
  `${currency} ${Number(amount || 0).toLocaleString()}`;

/**
 * Booking stats shared by a single listing's metrics and an organizer's
 * totals: { bookings: { total, pending, confirmed, failed, travellers,
 * lastBookingAt }, revenue: [{ currency, amount, bookings }] }.
 * Travellers and revenue count confirmed bookings only.
 */
const BookingMetrics = ({ metrics }) => {
  const { bookings, revenue = [] } = metrics;

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Bookings" value={bookings.total} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Confirmed" value={bookings.confirmed} valueStyle={{ color: "#389e0d" }} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Pending" value={bookings.pending} valueStyle={{ color: "#d48806" }} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Failed" value={bookings.failed} valueStyle={{ color: "#cf1322" }} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Travellers (confirmed)" value={bookings.travellers} />
          </Card>
        </Col>
        <Col xs={12} md={18}>
          <Card size="small">
            <Statistic
              title="Last booking"
              value={bookings.lastBookingAt ? moment(bookings.lastBookingAt).format("YYYY-MM-DD HH:mm") : "—"}
            />
          </Card>
        </Col>
      </Row>

      <div style={{ marginTop: 16 }}>
        <Text strong>Revenue (confirmed bookings)</Text>
        {revenue.length ? (
          <Table
            style={{ marginTop: 8 }}
            size="small"
            rowKey="currency"
            pagination={false}
            dataSource={revenue}
            columns={[
              { title: "Currency", dataIndex: "currency", key: "currency" },
              {
                title: "Amount",
                key: "amount",
                render: (_, row) => formatMoney(row.currency, row.amount),
              },
              { title: "Bookings", dataIndex: "bookings", key: "bookings" },
            ]}
          />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No confirmed revenue yet" />
        )}
      </div>
    </div>
  );
};

export default BookingMetrics;
